module.exports = __webpack_public_path__ + "fonts/font.f214e905.woff";